export default "__VITE_ASSET__DdHAoIQ3__"